import config from 'js/app/config';

export const CARD_IMAGE_DIMENSIONS = {
  desktop: {
    height: 216,
    width: 330,
  },
  mobile: {
    height: 109,
    width: 167,
  },
} as const;

export const HUB_CARD_DIMENSIONS = {
  desktop: {
    width: 330,
    height: 462,
  },
  mobile: {
    width: 167,
    height: 258,
  },
} as const;

export const HERO_BANNER_CONTENT_CONTAINER_MAX_WIDTH = 1336;

export const FIRST_PAGE_NUMBER = 1;

export const DEFAULT_ARTICLE_AUTHOR = {
  name: 'Coursera',
  jobTitle: 'Writer',
  externalWebsites: [
    'https://www.facebook.com/Coursera',
    'https://twitter.com/coursera',
    'https://www.linkedin.com/company/coursera',
    'https://www.instagram.com/coursera/',
    'https://www.youtube.com/user/coursera',
  ],
  description:
    'Coursera is the global online learning platform that offers anyone, anywhere access to online courses and degrees from world-class universities and companies.',
  knowsAbout: ['Online Education', 'Online Courses', 'Online Learning', 'Online Degrees', 'Online Certificates'].map(
    (knows) => ({
      title: knows,
      slug: knows.toLowerCase().replace(' ', '-'),
      locale: {
        language: 'global',
        country: 'global',
      },
    })
  ),
  image: `${config.url.imageProxyRoot}https://coursera.s3.amazonaws.com/media/coursera-logo-square.png`,
};
